import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GameSelector from "./GameSelector";
import { LanguageProvider } from "./LanguageContext";
import { ThemeProvider } from "./ThemeManager";
import DesignSprintGuide from "./guidebook/DesignSprintGuide";
import AboutPage from "./AboutPage" 

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <Routes>
            <Route path="/" element={<GameSelector />} />
            {/* Add this route for /beta */}
            <Route path="/beta" element={<GameSelector />} />
            <Route path="/design-sprint-hu" element={<DesignSprintGuide />} />
            <Route path="/about" element={<AboutPage onReturnHome={() => (window.location.href = "/")} />} />
          </Routes>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);